import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";

export default function RouteLoader() {
  const { pathname } = useLocation();
  const [show, setShow] = useState(false);
  const first = useRef(true);

  useEffect(() => {
    if (first.current) {
      first.current = false;
      return;
    }
    setShow(true);
    const t = setTimeout(() => setShow(false), 850);
    return () => clearTimeout(t);
  }, [pathname]);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          data-testid="route-loader"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.25 }}
          className="fixed inset-0 z-[90] bg-navy-950/85 backdrop-blur-md flex flex-col items-center justify-center gap-6"
        >
          <div className="relative w-24 h-24">
            <motion.div
              className="absolute inset-0 rounded-full border-2 border-transparent border-t-gold"
              animate={{ rotate: 360 }}
              transition={{ repeat: Infinity, duration: 1.1, ease: "linear" }}
            />
            <div className="absolute inset-2 rounded-full bg-white flex items-center justify-center p-2 shadow-[0_0_40px_rgba(212,175,55,0.3)]">
              <img src="/logo-mark.png" alt="Claimspace LegalTech" className="w-full h-full object-contain" />
            </div>
          </div>
          <p className="text-[10px] uppercase tracking-[0.5em] text-gold">Claimspace LegalTech</p>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
